import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

// const getProducts = async () => {
//   try {
//     const response = await axios.get(`${base_url}Products`);
//     console.log("API Response:", response.data); // Debug
//     return Array.isArray(response.data) ? response.data : response.data.products || [];
//   } catch (error) {
//     throw new Error(error.response?.data?.message || "Failed to fetch products");
//   }
// };

// src/features/products/productService.js
const getProducts = async (searchTerm = '') => {
  try {
    const url = searchTerm
      ? `${base_url}Products?search=${encodeURIComponent(searchTerm)}`
      : `${base_url}Products`;
    const response = await axios.get(url);
    return Array.isArray(response.data) ? response.data : response.data.products || [];
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch products');
  }
};

const getSingleProduct = async (id) => {
  try {
    const response = await axios.get(`${base_url}Products/${id}`);
    return response.data || {};
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch product");
  }
};

const categoryAndSubcategoryWiseProductList = async (category, subCategory) => {
  try {
    const response = await axios.get(`${base_url}Products/products/${category}/${subCategory}`);
    return response.data || [];
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch products by category and subcategory");
  }
};

const addTowishlist = async (prodId) => {
  try {
    const response = await axios.put(`${base_url}user/addwishlist`, { prodId }, config);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to add to wishlist");
  }
};

export const productService = {
  getProducts,
  getSingleProduct,
  categoryAndSubcategoryWiseProductList,
  addTowishlist
};